// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner_banner__nhYFa","bannerImage":"Banner_bannerImage__FLtgb"};